/* eslint-disable */
import axios from 'axios'
import Auth from '../lib/Auth'
import constants from '../constants/constants'
// TODO fix
// eslint-disable-next-line import/no-cycle
import * as ambassadorsActions from './ambassadors'
// TODO fix
// eslint-disable-next-line import/no-cycle
import * as impressionsActions from './impressions'
// TODO fix
// eslint-disable-next-line import/no-cycle
import * as reviewsActions from './reviews'
// TODO fix
// eslint-disable-next-line import/no-cycle
import * as usersActions from './users'
import * as locationActions from './location'

// ambassadors
export const UPDATE_FORM_AMBASSADOR = 'UPDATE_FORM_AMBASSADOR'
export const SUBMITTING_AMBASSADOR_FORM = 'SUBMITTING_AMBASSADOR_FORM'
export const SUBMITTED_AMBASSADOR_FORM = 'SUBMITTED_AMBASSADOR_FORM'
export const ERROR_SUBMITTING_AMBASSADOR_FORM =
  'ERROR_SUBMITTING_AMBASSADOR_FORM'
export const RESET_AMBASSADOR = 'RESET_AMBASSADOR'
export const SET_NEXT_STEP = 'SET_NEXT_STEP'
export const UPDATING_AMBASSADOR = 'UPDATING_AMBASSADOR'
export const UPDATED_AMBASSADOR = 'UPDATED_AMBASSADOR'
export const ERROR_UPDATING_AMBASSADOR = 'ERROR_UPDATING_AMBASSADOR'
export const FETCHING_AMBASSADOR = 'FETCHING_AMBASSADOR'
export const RECEIVED_AMBASSADOR = 'RECEIVED_AMBASSADOR'
export const ERROR_FETCHING_AMBASSADOR = 'ERROR_FETCHING_AMBASSADOR'
export const FETCHING_AMBASSADOR_CAMPAIGNS = 'FETCHING_AMBASSADOR_CAMPAIGNS'
export const RECEIVED_AMBASSADOR_CAMPAIGNS = 'RECEIVED_AMBASSADOR_CAMPAIGNS'
export const ERROR_FETCHING_AMBASSADOR_CAMPAIGNS =
  'ERROR_FETCHING_AMBASSADOR_CAMPAIGNS'
export const FETCHING_AMBASSADOR_PAYMENTS = 'FETCHING_AMBASSADOR_PAYMENTS'
export const RECEIVED_AMBASSADOR_PAYMENTS = 'RECEIVED_AMBASSADOR_PAYMENTS'
export const ERROR_FETCHING_AMBASSADOR_PAYMENTS =
  'ERROR_FETCHING_AMBASSADOR_PAYMENTS'
export const CREATING_PENDING_PAYMENT = 'CREATING_PENDING_PAYMENT'
export const ADD_PENDING_PAYMENT = 'ADD_PENDING_PAYMENT'

// user
export const FETCHING_VIEWER = 'FETCHING_VIEWER'
export const RECEIVED_VIEWER = 'RECEIVED_VIEWER'
export const UPDATING_VIEWER = 'UPDATING_VIEWER'
export const UPDATED_VIEWER = 'UPDATED_VIEWER'
export const ERROR_FETCHING_VIEWER = 'ERROR_FETCHING_VIEWER'
export const ERROR_UPDATING_VIEWER = 'ERROR_UPDATING_VIEWER'

// app
export const APP_INITIALISED = 'APP_INITIALISED'
export const FETCH_IP = 'FETCH_IP'
export const CHANGE_COUNTRY = 'CHANGE_COUNTRY'
export const ASKING_FOR_POSITION = 'ASKING_FOR_POSITION'
export const RECEIVED_POSITION = 'RECEIVED_POSITION'
export const GET_POSITION_DENIED = 'GET_POSITION_DENIED'

// auth
export const HANDLE_AUTH_MODAL = 'HANDLE_AUTH_MODAL'
export const IS_LOG_IN = 'IS_LOG_IN'
export const CONTINUE_SIGN_UP = 'CONTINUE_SIGN_UP'
export const SIGN_UP_BACK = 'SIGN_UP_BACK'
export const AUTHENTICATING = 'AUTHENTICATING'
export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const INCORRECT_CREDENTIALS = 'INCORRECT_CREDENTIALS'
export const ERROR_AUTHENTICATING = 'ERROR_AUTHENTICATING'
export const HANDLE_TOKEN = 'HANDLE_TOKEN'

// review comments
export const UPDATED_REVIEWS = 'UPDATED_REVIEWS'

const list = {
  ambassadors: {
    all: {
      updated: UPDATED_AMBASSADOR
    },
    ambassador: {
      fetching: FETCHING_AMBASSADOR,
      received: RECEIVED_AMBASSADOR,
      error: ERROR_FETCHING_AMBASSADOR
    },
    payments: {
      fetching: FETCHING_AMBASSADOR_PAYMENTS,
      received: RECEIVED_AMBASSADOR_PAYMENTS,
      error: ERROR_FETCHING_AMBASSADOR_PAYMENTS
    }
  },
  reviews: {
    all: {
      updated: UPDATED_REVIEWS
    }
  },
  user: {
    viewer: {
      fetching: FETCHING_VIEWER,
      received: RECEIVED_VIEWER,
      error: ERROR_FETCHING_VIEWER
    }
  }
}

export const fetchData =
  ({ path, type, subtype, skip, _id, isNew }) =>
  async (dispatch) => {
    dispatch({ type: list[type][subtype].fetching, _id, isNew })
    const result = await axios
      .get(path)
      .then((res) => {
        if (!res.data || res.data.err) {
          dispatch({
            type: list[type][subtype].error,
            _id,
            isNew
          })
          return [res.data.err, null]
        }
        dispatch({
          type: list[type][subtype].received,
          data: res.data,
          _id,
          isNew
        })
        return [null, res.data]
      })
      .catch((err) => {
        console.error(err)
        dispatch({ type: list[type][subtype].error, _id, isNew })
        return [err, null]
      })
    return result
  }

// value must be an object
export const updateField =
  ({ type, _id, value }) =>
  (dispatch) => {
    dispatch({
      type: list[type].all.updated,
      _id,
      value
    })
  }

export const ifLoggedIn = (callback) => (dispatch) => {
  if (!Auth.isUserApiAuthenticated()) {
    dispatch({
      type: HANDLE_AUTH_MODAL,
      value: true
    })
  } else {
    dispatch(callback)
  }
}

export const logOut =
  (cb = () => {}) =>
  async (dispatch) => {
    try {
      await axios.post(constants.api.auth.logout)

      Auth.removeUserID()
      Auth.removeUsername()
      Auth.removeApiToken()
      dispatch({ type: LOG_OUT })

      if (typeof cb === 'function') cb()
    } catch (err) {
      window.alert('Failed to log out')
    }
  }

export const handleLocalLogin =
  ({ email, password }) =>
  (dispatch) => {
    dispatch({
      type: AUTHENTICATING,
      method: 'local'
    })
    const user = { email, password }
    axios
      .post(constants.api.auth.login, user)
      .then((res) => {
        if (res.data.success && res.data.token) {
          dispatch(logIn({ loginData: res.data }))
        } else {
          dispatch({ type: INCORRECT_CREDENTIALS })
        }
      })
      .catch(() => {
        dispatch({ type: INCORRECT_CREDENTIALS })
      })
  }

export const logIn =
  ({ loginData }) =>
  (dispatch) => {
    // update the JWT token as a default header
    axios.defaults.headers.common.Authorization = `bearer ${loginData.token}`
    Auth.initializeWith(loginData)
    dispatch({ type: LOG_IN })
    dispatch({
      type: HANDLE_AUTH_MODAL,
      value: false
    })
    dispatch(users.fetchViewer(loginData.user.username))
  }

export const handleSignUp =
  ({ user }) =>
  (dispatch) => {
    dispatch({
      type: AUTHENTICATING,
      method: 'signup'
    })
    axios
      .post(constants.api.auth.signup, user)
      .then((res) => {
        if (res.data.success) {
          dispatch(handleLocalLogin(user))
        } else {
          dispatch({ type: ERROR_AUTHENTICATING })
        }
      })
      .catch(() => {
        dispatch({ type: ERROR_AUTHENTICATING })
      })
  }

export const ambassadors = ambassadorsActions
export const impressions = impressionsActions
export const reviews = reviewsActions
export const users = usersActions
export const location = locationActions
